import { useNavigate, useParams } from 'react-router-dom';
export const HostAssignmentModal = ({
  showHostModal,
  isAssigningHost,
  canBecomeHost,
  hostCheckMessage,
  assignUserAsHost,
  userData
}: any) => {
  if (!showHostModal) return null;
  const navigate = useNavigate();
  const { id } = useParams<string>();
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
        <div className="flex items-center mb-4">
          <div className="w-12 h-12 rounded-full bg-yellow-100 flex items-center justify-center mr-4">
            <svg
              className="w-6 h-6 text-yellow-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h3 className="text-xl font-bold text-gray-900">
            {canBecomeHost ? 'No Host Assigned' : 'Waiting for Host'}
          </h3>
        </div>

        <p className="text-gray-600 mb-6 leading-relaxed">{hostCheckMessage}</p>

        <div className="flex gap-3 justify-end">
          {!isAssigningHost && userData?.role !== 'Studio Guest' && (
            <button
              onClick={() => {
                navigate(`/videos/${id}`);
              }}
              className="px-4 py-2 text-gray-700 bg-gray-200 rounded hover:bg-gray-300 transition-colors">
              Cancel
            </button>
          )}

          {canBecomeHost && (
            <button
              onClick={assignUserAsHost}
              disabled={isAssigningHost}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors disabled:bg-blue-400 disabled:cursor-not-allowed flex items-center gap-2">
              {isAssigningHost ? (
                <>
                  <svg
                    className="animate-spin h-4 w-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24">
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    />
                  </svg>
                  Assigning...
                </>
              ) : (
                'Yes, Become Host'
              )}
            </button>
          )}
        </div>

        {!canBecomeHost && userData?.role === 'Studio Guest' && (
          <div className="mt-4 p-3 bg-blue-50 rounded border border-blue-200">
            <p className="text-sm text-blue-800">
              <strong>Tip:</strong>
              {`You can also refresh this page in a few minutes.`}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
